export default __webpack_public_path__ + "static/media/video-play-img.106bda34.svg";